import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/Button';
import { getActiveWorkspace, getIsRootWorkspace } from '../../app/AppUtilityFunctions';

interface NoMatchPageProps {
  groupsList: unknown[] | null;
  currentUserGroup: string;
}

export default function NoMatchPage({ groupsList, currentUserGroup }: NoMatchPageProps) {
  const navigate = useNavigate();

  function handleClick() {
    const activeWorkspace = getActiveWorkspace(groupsList, currentUserGroup);
    const isRoot = getIsRootWorkspace(activeWorkspace);
    navigate(isRoot ? '/in/account/workspace' : '/in/folder/root');
  }

  return (
    <div className="flex flex-col items-center gap-4 py-20">
      <h2 className="text-2xl font-semibold">Could not find page!</h2>
      <Button onClick={handleClick}>Return home</Button>
    </div>
  );
}
